exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".post-tags {\n  margin-top: 20px;\n}\n.post-tags span {\n  background: #1c1c1c;\n  color: #fff;\n  font-size: 12px;\n  padding: 3px 6px;\n  text-transform: uppercase;\n  margin-right: 5px;\n}\n.related-posts .post-thumb img {\n  width: 130% !important;\n  max-width: 130% !important;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n@media (max-width: 576px) {\n.widget {\n    margin-left: 15px !important;\n    margin-right: 15px !important;\n}\n#post-page #campaign {\n    padding-left: 15px;\n    padding-bottom: 10px;\n}\n}", ""]);

// exports
